import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FeedbackModal } from "./FeedbackModal";

export function FeedbackButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  // Never render inside the public embed widget: it ships in an iframe on
  // third-party pages and must show only Stew's own UI.
  if (pathname.startsWith("/stew-widget")) return null;


  return (
    <>
      {!isOpen && (
        <Button
          onClick={() => setIsOpen(true)}
          data-feedback-ui
          // On phones, sit above the mobile bottom nav (h-16) plus the safe-area
          // inset so the button never covers a nav item or the /support composer.
          // Mobile: bottom-right; desktop: bottom-left.
          className="fixed z-50 rounded-full shadow-lg gap-2 left-auto sm:left-4 right-4 sm:right-auto bottom-[calc(4rem+env(safe-area-inset-bottom,0px)+0.75rem)] sm:bottom-4"
          size="sm"
        >
          <MessageSquare className="h-4 w-4" />
          <span className="hidden sm:inline">Feedback</span>
        </Button>
      )}

      <FeedbackModal open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
}
